export default __webpack_public_path__ + "static/media/guide_01_03.ab5969f3.png";